import { pathKey } from "./path-key"
import { containsDirectory, sameDirectory } from "./paths"

export function renamedDirectory(value: string, previous: string, directory: string) {
  const source = pathKey(previous)
  const current = pathKey(value)
  if (sameDirectory(current, source)) return directory
  if (!containsDirectory(source, current)) return value
  return `${pathKey(directory)}${current.slice(source.length)}`
}
